import { render } from "./GroupwiseSalaryPovisionAllocationPage.vue?vue&type=template&id=973d11c6"
import script from "./GroupwiseSalaryPovisionAllocationPage.vue?vue&type=script&lang=js"
export * from "./GroupwiseSalaryPovisionAllocationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__